import * as yup from "yup"
import {
  getFieldMessages,
  fullNameField,
  phoneField,
  requiredEmailField,
  requiredFileField,
  checkboxField,
  DOC_MIME_TYPES,
  type FormLanguage,
} from "../../common/forms"

export function createSchema(language: FormLanguage, checkboxRequired: boolean) {
  const m = getFieldMessages(language)

  return yup.object({
    fullName: fullNameField(m),
    phone: phoneField(m),
    email: requiredEmailField(m),
    cvFile: requiredFileField(m, DOC_MIME_TYPES, m.fileTypeDocs),
    checkbox: checkboxField(m, checkboxRequired),
  })
}

export type FormValues = yup.InferType<ReturnType<typeof createSchema>>

export const defaultValues: FormValues = {
  fullName: "",
  phone: "",
  email: "",
  cvFile: undefined as unknown as File,
  checkbox: false,
}
